import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ComboChart = function ComboChart(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$secondaryColor = _ref.secondaryColor,
    secondaryColorProp = _ref$secondaryColor === void 0 ? '#6F4EF6' : _ref$secondaryColor,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  var secondaryColor = !ignoreColor ? secondaryColorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M30.3969 11.7308L29.0801 10.2256L17.5935 20.2744L18.9103 21.7796L30.3969 11.7308Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M14.4634 20.2347L6.88867 13.2919L5.53727 14.7663L13.112 21.7091L14.4634 20.2347Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M32 13C29.8 13 28 11.2 28 9C28 6.8 29.8 5 32 5C34.2 5 36 6.8 36 9C36 11.2 34.2 13 32 13ZM32 7C30.9 7 30 7.9 30 9C30 10.1 30.9 11 32 11C33.1 11 34 10.1 34 9C34 7.9 33.1 7 32 7Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M4 16C1.8 16 0 14.2 0 12C0 9.8 1.8 8 4 8C6.2 8 8 9.8 8 12C8 14.2 6.2 16 4 16ZM4 10C2.9 10 2 10.9 2 12C2 13.1 2.9 14 4 14C5.1 14 6 13.1 6 12C6 10.9 5.1 10 4 10Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M16 27C13.8 27 12 25.2 12 23C12 20.8 13.8 19 16 19C18.2 19 20 20.8 20 23C20 25.2 18.2 27 16 27ZM16 21C14.9 21 14 21.9 14 23C14 24.1 14.9 25 16 25C17.1 25 18 24.1 18 23C18 21.9 17.1 21 16 21Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M41.0003 17L33.8003 11.6L35.0003 10L42.2003 15.4L41.0003 17Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M44 22C41.8 22 40 20.2 40 18C40 15.8 41.8 14 44 14C46.2 14 48 15.8 48 18C48 20.2 46.2 22 44 22ZM44 16C42.9 16 42 16.9 42 18C42 19.1 42.9 20 44 20C45.1 20 46 19.1 46 18C46 16.9 45.1 16 44 16Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M45 43H3V20H5V41H43V26H45V43Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M17 31H15V42H17V31Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M33 17H31V42H33V17Z",
      fill: color
    })]
  });
};
export default ComboChart;